import template from './tdar-availability-request-list.html.twig';
import './tdar-availability-request-list.scss';

const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Shopware.Component.register('tdar-availability-request-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('listing'),
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            sortBy: 'createdAt',
            sortDirection: 'DESC',
            naturalSorting: false,
            total: 0,
            showDeleteModal: false,
            itemToDelete: null,
            showClearModal: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdar_availability_request');
        },

        columns() {
            return [
                { property: 'createdAt',     label: this.$tc('TopdataAvailabilityRequestSW6.admin.createdAt'),     allowResize: true },
                { property: 'productNumber', label: this.$tc('TopdataAvailabilityRequestSW6.admin.productNumber'), primary: true, allowResize: true },
                { property: 'productName',   label: this.$tc('TopdataAvailabilityRequestSW6.admin.productName'),   allowResize: true },
                { property: 'email',         label: this.$tc('TopdataAvailabilityRequestSW6.admin.email'),         allowResize: true },
                { property: 'customerNumber', label: this.$tc('TopdataAvailabilityRequestSW6.admin.customerNumber'), allowResize: true },
                { property: 'ipAddress',     label: this.$tc('TopdataAvailabilityRequestSW6.admin.ip'),             allowResize: true },
                { property: 'status',        label: this.$tc('TopdataAvailabilityRequestSW6.admin.status'),        allowResize: true, width: '100px' },
            ];
        },
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.setTerm(this.term);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            return this.repository.search(criteria, Shopware.Context.api).then((res) => {
                this.items = res;
                this.total = res.total;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onRefresh() {
            this.getList();
        },

        onClear() {
            this.showClearModal = true;
        },

        onCloseClearModal() {
            this.showClearModal = false;
        },

        onConfirmClear() {
            this.isLoading = true;

            const criteria = new Criteria(1, 500);
            this.repository.search(criteria, Shopware.Context.api).then((res) => {
                const ids = res.getIds();
                if (ids.length === 0) {
                    this.isLoading = false;
                    this.onCloseClearModal();
                    return;
                }
                return Promise.all(ids.map((id) => this.repository.delete(id, Shopware.Context.api)));
            }).then(() => {
                this.isLoading = false;
                this.term = null;
                this.page = 1;
                this.onCloseClearModal();
                this.getList();
                this.createNotificationSuccess({
                    message: this.$tc('TopdataAvailabilityRequestSW6.admin.cleared'),
                });
            }).catch(() => {
                this.isLoading = false;
                this.onCloseClearModal();
            });
        },

        setStatus(item, status) {
            item.status = status;
            this.repository.save(item, Shopware.Context.api).then(() => {
                this.getList();
                this.createNotificationSuccess({
                    message: this.$tc('TopdataAvailabilityRequestSW6.admin.saved'),
                });
            });
        },

        onOpenDetail(item) {
            this.$router.push({
                name: 'tdar.availability.request.detail',
                params: { id: item.id },
            });
        },

        onDelete(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
            this.itemToDelete = null;
        },

        onConfirmDelete() {
            if (!this.itemToDelete) {
                return;
            }
            this.repository.delete(this.itemToDelete.id, Shopware.Context.api).then(() => {
                this.onCloseDeleteModal();
                this.getList();
            });
        },

        statusVariant(status) {
            if (status === 'done') {
                return 'success';
            }
            if (status === 'spam') {
                return 'danger';
            }
            return 'info';
        },

        statusLabel(status) {
            if (status === 'done') {
                return this.$tc('TopdataAvailabilityRequestSW6.admin.statusDone');
            }
            if (status === 'spam') {
                return this.$tc('TopdataAvailabilityRequestSW6.admin.statusSpam');
            }
            return this.$tc('TopdataAvailabilityRequestSW6.admin.statusNew');
        },
    },
});
